import axios from "axios";

let baseUrl = "";
let clientCode = "";
let sessionKey = "";

const Server = {
  init: (userObject) => {
    baseUrl = userObject.baseUrl;
    clientCode = userObject.clientCode;
    sessionKey = userObject.sessionKey;
  },

  getPurchaseReport: async (startDate, endDate) => {
    const url = `${baseUrl}v1/packaging/purchase`;
    return await axios.get(url, {
      params: {
        startDate,
        endDate,
      },
      headers: {
        clientCode,
        sessionKey,
      },
      withCredentials: true,
    });
  },

  getSalesReport: async (startDate, endDate) => {
    const url = `${baseUrl}v1/packaging/sales`;
    return await axios.get(url, {
      params: {
        startDate,
        endDate,
      },
      headers: {
        clientCode,
        sessionKey,
      },
      withCredentials: true,
    });
  },

  getDistributionReport: async (params) => {
    const url = `${baseUrl}v1/central-purchasing/distribute-goods`;
    return await axios.get(url, {
      params,
      headers: {
        clientCode,
        sessionKey,
      },
      withCredentials: true,
    });
  },

  getGSTPayableReport: async (params) => {
    const url = `${baseUrl}v1/sales/locations`;
    return await axios.get(url, {
      params,
      headers: {
        clientCode,
        sessionKey,
      },
      withCredentials: true,
    });
  },

  getOverAndShortReport: async (params) => {
    const url = `${baseUrl}v1/over-or-short`;
    return await axios.get(url, {
      params,
      headers: {
        clientCode,
        sessionKey,
      },
      withCredentials: true,
    });
  },

  exportOverAndShortReportToCSV: async (params) => {
    const url = `${baseUrl}v1/over-or-short/csv`;
    return await axios.get(url, {
      params,
      headers: {
        clientCode,
        sessionKey,
      },
      withCredentials: true,
    });
  },

  exportPNPReportToCSV: async (params) => {
    const url = `${baseUrl}v1/generated-reports/sales-paid-with-cash/csv`;
    return await axios.get(url, {
      params,
      headers: {
        clientCode,
        sessionKey,
      },
      withCredentials: true,
    });
  },

  getPNPReportStatus: async (params, ajaxRequest) => {
    const url = `${baseUrl}v1/generated-reports/sales-paid-with-cash`;
    if (ajaxRequest) {
      return await axios.get(url, {
        params: { ...params, doNotReturnReportData: true },
        headers: {
          clientCode,
          sessionKey,
        },
        cancelToken: ajaxRequest.token,
        withCredentials: true,
      });
    }

    return await axios.get(url, {
      params: { ...params, doNotReturnReportData: true },
      headers: {
        clientCode,
        sessionKey,
      },
      withCredentials: true,
    });
  },

  getProductGroupsIndented: async (pimBaseUrl, clientCode, sessionKey) => {
    return await axios.get(`${pimBaseUrl}v1/product/group/indented`, {
      headers: { clientCode, sessionKey },
      withCredentials: true,
    });
  },

  getProductCategoriesIndented: async (pimBaseUrl, clientCode, sessionKey) => {
    return await axios.get(`${pimBaseUrl}v1/product/category/indented`, {
      headers: { clientCode, sessionKey },
      withCredentials: true,
    });
  },

  getCustomers: async (crmBaseUrl, clientCode, sessionKey) => {
    return await axios.get(`${crmBaseUrl}v1/customers`, {
      headers: { clientCode, sessionKey },
      withCredentials: true,
      params: { skip: 0, take: 100000 },
    });
  },

  searchNameIncrementally: async (requestBody) => {
    requestBody.status = "ALL_EXCEPT_ARCHIVED.";
    return await requestERPLYData(requestBody);
  },

  getAllWarehousesNew: async (baseUrl, keys, orderBy, orderDirection) => {
    if (orderBy && orderDirection) {
      return await axios.get(`${baseUrl}v1/warehouse`, {
        headers: { clientCode: keys.clientCode, sessionKey: keys.sessionKey },
        withCredentials: true,
        params: { orderBy, orderDirection },
      });
    } else {
      return await axios.get(`${baseUrl}v1/warehouse`, {
        headers: { clientCode: keys.clientCode, sessionKey: keys.sessionKey },
        withCredentials: true,
      });
    }
  },

  getCAFAConfig: async (baseUrl, keys, level_id) => {
    return await axios.get(`${baseUrl}configuration`, {
      headers: { clientCode: keys.clientCode, sessionKey: keys.sessionKey },
      withCredentials: true,
      params: {
        level_id,
        application: "bo_ui",
        level: "USER",
        name: "userpreferences",
      },
    });
  },

  getCustomerGroups: async (baseUrl, keys) => {
    return await axios.get(`${baseUrl}v1/customers/groups/indented`, {
      headers: { clientCode: keys.clientCode, sessionKey: keys.sessionKey },
      withCredentials: true,
    });
  },

  getTaxExemptReport: async (params) => {
    if (params) {
      return await axios.get(`${baseUrl}v1/customers/tax-exempt`, {
        headers: { clientCode, sessionKey },
        params,
        withCredentials: true,
      });
    }

    return await axios.get(`${baseUrl}v1/customers/tax-exempt`, {
      headers: { clientCode, sessionKey },
      withCredentials: true,
    });
  },
};

export const requestERPLYData = (requestData) => {
  const requestFormData = new FormData();
  Object.entries(requestData).forEach((fieldValue) => {
    const [key, value] = fieldValue;
    requestFormData.set(`${key}`, `${value}`);
  });
  const options = {
    method: "post",
    headers: { "Content-type": "multipart/form-data" },
    url: `https://${requestData.clientCode}.erply.com/api/`,
    data: requestFormData,
    withCredentials: true,
  };
  return axios(options);
};

export default Server;
